export class DateFormatter {

  public static formatDate2(value: any, format?: any, pipeFormat?: any): string {
    if (!value) return '';
    
    const date = new Date(value);

    // if (pipeFormat) {
    //   //return DateFormatter.formatDate(date, pipeFormat);
    //   return date;
    // }
    
    if (format?.format) {
      return date.toLocaleDateString(format.locale || 'en-US', format.options || {});
    }
    return date.toLocaleDateString();
  }

  static formatDate3(value: any, format?: string): string {
    if (!value) return '';
    
    const date = new Date(value);
    if (isNaN(date.getTime())) return value.toString();
    
    if (format) {
      // Simple format handling - extend as needed
      switch (format) {
        case 'short':
          return date.toLocaleDateString();
        case 'long':
          return date.toLocaleDateString('en-US', { 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric',
          });
        case 'datetime':
          return date.toLocaleString();
        default:
          return date.toLocaleDateString();
      }
    }
    
    return date.toLocaleDateString();
  }

  static formatDate(date: Date, format: string): string {
    if (!date) return '';

    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    // Add padding for single digit values
    const pad = (num: number): string => num < 10 ? `0${num}` : `${num}`;

    // Replace format tokens with actual values
    return format
      .replace(/yyyy/g, year.toString())
      .replace(/yy/g, year.toString().slice(-2))
      .replace(/MM/g, pad(month))
      .replace(/M/g, month.toString())
      .replace(/dd/g, pad(day))
      .replace(/d/g, day.toString())
      .replace(/HH/g, pad(hours))
      .replace(/H/g, hours.toString())
      .replace(/hh/g, pad(hours > 12 ? hours - 12 : hours === 0 ? 12 : hours))
      .replace(/h/g, (hours > 12 ? hours - 12 : hours === 0 ? 12 : hours).toString())
      .replace(/mm/g, pad(minutes))
      .replace(/m/g, minutes.toString())
      .replace(/ss/g, pad(seconds))
      .replace(/s/g, seconds.toString())
      .replace(/tt/g, hours >= 12 ? 'PM' : 'AM')
      .replace(/t/g, hours >= 12 ? 'P' : 'A');
  }

  static parseDate(dateStr: string, format: string): Date | null {
    // Basic parsing for MM/dd/yyyy format
    // In a production app, you'd want more robust parsing
    try {
      const parts = dateStr.split('/');
      if (format === 'MM/dd/yyyy' && parts.length === 3) {
        const month = parseInt(parts[0], 10) - 1;
        const day = parseInt(parts[1], 10);
        const year = parseInt(parts[2], 10);
        return new Date(year, month, day);
      }
      // Default fallback
      return new Date(dateStr);
    } catch {
      return null;
    }
  }

  //#region datetime-local conversion functions

  static toISOValidDateInput(date: Date): string {
    return date.toISOString().slice(0, 16);
  }

  /**
   * Converts a Date object to ISO string format required by datetime-local input
   * Format: YYYY-MM-DDThh:mm
   */
  static dateToInputValue(date: Date | null): string {
    if (!date) return '';

    // Create the ISO string and remove seconds and milliseconds
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    // Format: YYYY-MM-DDThh:mm
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  /**
   * Parses an input value from the datetime-local input into a Date object
   */
  static inputValueToDate(value: string): Date | null {
    if (!value) return null;
    return new Date(value);
  }

  //#endregion
}
